// extracted by mini-css-extract-plugin
export var alternate = "_1a-j";
export var black = "_1a-6";
export var blue = "_1a-f";
export var blueLight = "_1a-e";
export var brand = "_1a-8";
export var darkMode = "_1a-b";
export var error = "_1a-a";
export var gray = "_1a-5";
export var grayBlue = "_1a-d";
export var iconWrapper = "_1a-3";
export var inactive = "_1a-7";
export var indigo = "_1a-g";
export var orange = "_1a-i";
export var pink = "_1a-h";
export var primary = "_1a-0";
export var purple = "_1a-9";
export var success = "_1a-4";
export var warning = "_1a-c";
export var white = "_1a-1";
export var whiteSuccess = "_1a-2";